import { CycleFib } from '@andywilliams/indicators';
import useStoredEventMarkers from './useStoredEventMarkers';

const DEFINITIONS = new Map(CycleFib.getEventDefinitions().map((d) => [d.id, d]));

// Cycle-fib events (DWLF-334) as chart markers (DWLF-447), stored nightly against the same
// legs the Fib Levels guides draw. `levels.formed` is left out: the guides already show a new leg.
export const CYCLE_FIB_MARKER_TYPES = [
  'cycleFib.retrace.reached.382',
  'cycleFib.retrace.reached.500',
  'cycleFib.retrace.reached.618',
  'cycleFib.retrace.reached.786',
  'cycleFib.golden_pocket.entered',
  'cycleFib.level.held',
  'cycleFib.level.rejected',
  'cycleFib.leg.invalidated',
  'cycleFib.extension.reached.1272',
  'cycleFib.extension.reached.1618',
];

// /v2/events row → the library shape registerEvents takes. The events API carries no level
// price for these rows, so the marker sits on its bar (the chart falls back to the candle).
export const toCycleFibLibraryEvent = (stored) => {
  if (!stored || typeof stored.eventType !== 'string' || !stored.eventType.startsWith('cycleFib.')) {return null;}
  const t = Date.parse(stored.eventTimestamp ?? stored.date);
  if (!Number.isFinite(t)) {return null;}
  const definition = DEFINITIONS.get(stored.eventType);
  return { id: stored.eventType, name: definition?.name, description: definition?.description, t, payload: {} };
};

export default function useBackendCycleFibEvents(symbol, { enabled = true } = {}) {
  return useStoredEventMarkers(enabled ? symbol : null, {
    eventTypes: CYCLE_FIB_MARKER_TYPES, toLibraryEvent: toCycleFibLibraryEvent, label: 'cycle fib',
  });
}
